import { useParameter } from '@hooks/use-parameter'
import { useTrackExternalLink } from '@hooks/use-track-external-link'
import { ENHANCED_COMPONENT_ROLE } from '@ui/enhanced-components/types'
import { getLinkTargetAttribute } from '@utils/is-webview'
import { SupportedQueryParams } from '@utils/parameters'
import queryString from 'query-string'
import { type SyntheticEvent, useContext } from 'react'

import { useIsIframe } from '../../../plugins/gatsby-plugin-espace-client'
import { TokenContext } from '../../../plugins/gatsby-plugin-espace-client/src/token-context'

type UseSubscriptionLinkPropsReturn = {
  href: string
  onClick: (event: SyntheticEvent) => void
  component: 'a'
  target: string
  'data-role': ENHANCED_COMPONENT_ROLE
}

export const useSubscriptionLinkProps = (
  slug: string
): UseSubscriptionLinkPropsReturn => {
  const trackExternalLink = useTrackExternalLink()
  const parameterOrigin = useParameter(SupportedQueryParams.Origin)
  const isIframe = useIsIframe()
  const token = useContext(TokenContext)

  const newSlug = queryString.stringifyUrl({
    url: slug,
    query: {
      [SupportedQueryParams.Origin]: parameterOrigin,
      [SupportedQueryParams.Iframe]: isIframe || undefined,
      token: token || undefined,
    },
  })

  return {
    href: newSlug,
    onClick: trackExternalLink,
    component: 'a',
    target: getLinkTargetAttribute(),
    'data-role': ENHANCED_COMPONENT_ROLE.MAIN,
  }
}
